import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { useImmer } from 'use-immer'
import { LeadForm } from '../LeadForm'
import s from './AddLeadModal.scss'

const AddLeadModal = ({ toggleAddLeadModal, addLeadModalOpen, createLead }) => {
  const [lead, setLead] = useImmer({ name: '', followUpDate: '' })

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={addLeadModalOpen}
        toggle={toggleAddLeadModal}
        size="xl"
      >
        <ModalHeader toggle={toggleAddLeadModal} className={s.modalHeader}>
          Add Lead
        </ModalHeader>
        <ModalBody>
          <LeadForm lead={lead} setLead={setLead} />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleAddLeadModal}>
            Cancel
          </Button>
          <Button
            className={s.saveBtn}
            onClick={() => {
              createLead(lead)
              toggleAddLeadModal()
            }}
            disabled={lead.name === ''}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default AddLeadModal
